import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue-demi';
import {
  AbSection,
  AbContainer,
  AbTitle,
  AbDescription,
  AbButton,
} from '../../ui';
import { CdnImg } from '@webplatform/cdn-image';

interface Props {
  data: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CtaSectionBanner',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: any;
};


const banner = computed(() => {
  let image = props.data.banner.src;

  return image;
});

return { __sfc: true,props, banner, AbSection, AbContainer, AbTitle, AbDescription, AbButton, CdnImg }
}

})